import React  from 'react'
import ProjectPage from 'containers/ProjectPage/Loadable'
import {
  Routes,
  Route,
} from 'react-router-dom'

export default () => (
  <Routes>
    <Route path=":hashId/*" element={<ProjectPage />} />
    <Route index element={<ProjectPage />} />
  </Routes>
)
